"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var clinicianReviewListConfig = function clinicianReviewListConfig(dataSource) {
  var columns = [{
    title: 'Patient Name',
    dataIndex: 'patientName',
    key: 'patientName',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.patientName);
    }
  }, {
    title: 'Type',
    dataIndex: 'type',
    key: 'type',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.type);
    }
  }, {
    title: 'Question',
    dataIndex: 'question',
    key: 'question',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.question);
    }
  }, {
    title: 'Rating',
    dataIndex: 'rating',
    key: 'rating',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.rating);
    }
  }, {
    title: 'Review',
    dataIndex: 'review',
    key: 'review',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.review);
    }
  }, {
    title: 'Month',
    dataIndex: 'month',
    key: 'month',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.month);
    }
  }, {
    title: 'Created Date',
    dataIndex: 'reviewCreatedDate',
    key: 'reviewCreatedDate',
    sorter: (0, _utils.timeSorter)('reviewCreatedDate'),
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, (0, _utils.formatDate)(record.reviewCreatedDate));
    }
  }, {
    title: 'Allow to use',
    dataIndex: 'allowToUse',
    key: 'allowToUse',
    render: function render(text, record) {
      return /*#__PURE__*/_react.default.createElement("span", null, record.allowToUse || 'no review');
    }
  }];
  return {
    columns: columns,
    dataSource: dataSource,
    rowKey: 'id'
  };
};
var _default = clinicianReviewListConfig;
exports.default = _default;